import { createSlice } from "@reduxjs/toolkit";
 
const initialState = {
  Head:  {
    "A_Transid": "",
    "A_Date": "",
    "A_Location": "",
    "Loc_Name": "",
    "A_Narration": "",
    "A_Status": "",
    "A_Confirm_Status": "",
    "CreatedBy": "",
    "CreatedDt": "",
    "ConfirmBy":"",
    "ConfirmDt":"",
    "A_Vendor":""
}
};


const SliceVendorDiscontinueChangeApprove = createSlice({
  name: "SliceVendorDiscontinueChangeApprove",
  initialState: { value: initialState },

  reducers: {
    Head_Set: (state, action) => {
      state.value.Head = action.payload;
    },
    VendorDiscontinueChangeApprove_Init: (state) => {
      state.value = initialState;
    },
  },
});

export const {Head_Set,VendorDiscontinueChangeApprove_Init } =  SliceVendorDiscontinueChangeApprove.actions;
export default SliceVendorDiscontinueChangeApprove.reducer;
